module.exports = __webpack_public_path__ + "img/F2b.44500923.svg";